import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FolderExplorerModal } from '@/explorer/FolderExplorerModal.organism';
import { useHomeScreenCurrentTab } from '@/homescreen/homescreen.store';
import { HOME_SCREEN_TABS } from '@/main/app.constants';
import { errorToast } from '@/utilities/toast.utilities';
import { Button } from '@seeqdev/qomponents';

interface CorporateDriveMessageProps {
  item?: any;
  itemId: string;
  itemName: string;
  onClose?: any;
  fetchInherited?: any;
  isAclModalLocationInHeader: boolean;
  aclModified?: any;
}

export const CorporateDriveMessage = ({
  item,
  onClose,
  aclModified,
  itemId,
  itemName,
  fetchInherited,
  isAclModalLocationInHeader,
}: CorporateDriveMessageProps) => {
  const { t } = useTranslation();
  const currentTab = useHomeScreenCurrentTab();
  const handleFolderExplorerClose = () => {
    setShowFolderExplorerModal(false);
    if (!aclModified) {
      onClose();
    }
  };

  const [showFolderExplorerModal, setShowFolderExplorerModal] = useState(false);

  const moveCorporate = () => {
    if (currentTab !== HOME_SCREEN_TABS.CORPORATE) {
      return setShowFolderExplorerModal(true);
    } else {
      return errorToast({
        messageKey: 'ITEM_ACL.ITEM_IN_CORPORATE_ERROR',
        messageParams: { item: itemName },
      });
    }
  };

  return (
    <>
      <div
        data-testid="corporateMessage"
        className="tw:border-t tw:border-b-3 tw:border-sq-darkest-gray tw:bg-sq-highlight-analysis tw:py-1.25 tw:leading-[1.5] tw:text-sq-text-color">
        {t('ITEM_ACL.CORPORATE_MESSAGE')}
        <Button
          testId="corporateMessageButton"
          onClick={moveCorporate}
          variant="outline"
          extraClassNames="tw:ml-3.75"
          label={t('ITEM_ACL.MOVE_CORPORATE')}
        />
        {showFolderExplorerModal && (
          <FolderExplorerModal
            onClose={handleFolderExplorerClose}
            item={item}
            currentTab={currentTab}
            corporateDriveMessage={true}
            itemId={itemId}
            itemName={itemName}
            isAclModalLocationInHeader={isAclModalLocationInHeader}
            aclModified={aclModified}
            fetchInherited={fetchInherited}
          />
        )}
      </div>
    </>
  );
};
